const defaultState = {
  winsObj: {
    res: '-1'      // control 0 is not found or invalid school code
  },
  province: [],
  district: [],
  commune: [],
  school: [],
  summary: null // summary data state for Dis, Pro, Kingdom
}

export default defaultState
